"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinhDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var sinhDependencies = exports.sinhDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSinh: _factoriesAny.createSinh
};